import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import messages, { DEMO_MODE_EDITOR, DEMO_MODE_PREVIEW, DEMO_MODE_SITE } from '../../components/message/messages';
import Message from '../../components/message';
import { isTemplate } from '../../services/is-template';

const getMessageType = viewMode => {
  if (viewMode === 'editor') {
    return DEMO_MODE_EDITOR;
  } else if (viewMode === 'preview') {
    return DEMO_MODE_PREVIEW;
  } else {
    return DEMO_MODE_SITE;
  }
};

const DemoMessageRoot = ({ viewMode, isDemoMode }) => {
  if (isDemoMode && !isTemplate()) {
    const messageType = getMessageType(viewMode);
    const message = messages[messageType];
    return <Message content={message.content()} type={message.type} alignment="center"/>;
  }
  return null;
};

DemoMessageRoot.propTypes = {
  viewMode: PropTypes.string.isRequired,
  isDemoMode: PropTypes.bool,
};

const mapStateToProps = state => ({
  viewMode: state.viewMode,
  isDemoMode: state.isDemoMode,
});

export default connect(mapStateToProps)(DemoMessageRoot);



// WEBPACK FOOTER //
// ./app/containers/demo-message-root/demo-message-root.js